import React from 'react';
import {ButtonType} from '@wix/devzai-utils-react';
import {classes, style} from './doppe-action-coupon-view.st.css';
import {
    CouponSourceType,
    DoppeActionTypeCouponView
} from '../../../components/doppe-action-type-coupon-view/doppe-action-type-coupon-view';
import {
    DoppeActionTypeWidgetInnerButton
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {
    DoppeActionTypeWidgetContentLayoutNew
} from '../../../components/doppe-action-type-widget-content-layout-new/doppe-action-type-widget-content-layout-new';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {WixMediaResource} from '@wix/devzai-common-wix';
import {
    DoppeActionTypeWidgetMediaResourceView
} from '../../../components/doppe-action-type-widget-media-resource-view/doppe-action-type-widget-media-resource-view';

export const DoppeActionCouponView = React.memo(function DoppeActionCouponView(
    props: {
        title?: string;
        description?: string;
        couponCode: string;
        couponImage?: WixMediaResource;
        linkUrl: string;
        couponButtonText?: string;
        reportGoalAchieved: () => void;
        actionId: string;
    }
) {
    const {
        couponImage,
        title,
        description,
        couponCode,
        linkUrl,
        couponButtonText = 'Continue to site',
        reportGoalAchieved,
        actionId,
    } = props;

    return (
        <DoppeActionTypeWidgetContentLayoutNew
            mainMedia={couponImage ? (
                <DoppeActionTypeWidgetMediaResourceView
                    mediaResource={couponImage}
                    showVideoControls={true}
                    playLoop={false}
                    autoPlay={false}
                    muted={false}
                />
            ) : null}
            footer={(
                <DoppeActionTypeWidgetInnerButton
                    buttonType={ButtonType.NormalButton}
                    tagName={'a'}
                    href={linkUrl}
                    target={'_blank'}
                    onClick={() => {
                        reportGoalAchieved();
                    }}
                >
                    {couponButtonText}
                </DoppeActionTypeWidgetInnerButton>
            )}
        >
            <DoppeActionTypeWidgetInnerTitle
                className={style(classes.couponName, {})}
            >
                {title ?? ''}
            </DoppeActionTypeWidgetInnerTitle>

            <DoppeActionTypeWidgetInnerDescription
                className={style(classes.couponDescription, {})}
            >
                {description ?? ''}
            </DoppeActionTypeWidgetInnerDescription>
            <DoppeActionTypeCouponView
                className={style(classes.couponView, {})}
                coupon={couponCode}
                couponSourceType={CouponSourceType.Action}
                actionId={actionId}
            />
        </DoppeActionTypeWidgetContentLayoutNew>
    );
});
